import { createReducer } from '@reduxjs/toolkit';

import { vehicleWidgetName as garageVehicleWidgetName } from 'Components/fitmentSearch/garage/garage';
import { dialogClosed } from 'Core/actions/dialog';
import { vehicleDiscardingRequested, vehicleSelected } from 'Core/actions/fitmentSearch/index';
import { fitmentResponseInitState, fitmentResponseReducer } from 'Core/reducers/fitmentSearch/common';

const initState = fitmentResponseInitState;

export default createReducer(initState, (builder) =>
  builder
    .addCase(dialogClosed, () => initState)
    .addCase(vehicleDiscardingRequested, () => initState)
    .addCase(vehicleSelected, (state, { meta: { vehicleWidgetName } }) =>
      vehicleWidgetName === garageVehicleWidgetName ? initState : state,
    )
    .addDefaultCase((state, action) => fitmentResponseReducer(state, action)),
);
